module.exports = __webpack_public_path__ + "img/popeye4.bc8f44d1.jpg";